import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useSession } from '@components/app/Session';
import { CreditCard } from '@generated-types';

import { getCreditCardsList } from './getCreditCardsList';

export const useCreditCardsList = ({ enabled }: { enabled: boolean } = { enabled: true }) => {
    const session = useSession();

    return useQuery<CreditCard[]>({
        queryKey: ['v4', 'credit-cards'],
        queryFn: getCreditCardsList,
        placeholderData: keepPreviousData,
        enabled: !!session.creditProfile && enabled,
    });
};
